







import { Component, Vue } from 'vue-property-decorator'

@Component({
  name:'GlobalFooter'
})
export default class GlobalFooter  extends Vue {

}
